import "react-dates/initialize";

import React, { useState } from "react";
import PropTypes from "prop-types";

import { DateRangePicker as DRP } from "react-dates";
import "react-dates/lib/css/_datepicker.css";
import "./DateRangePicker.scss";

import moment from "moment";

function DateRangePicker({ name, startDate, endDate, onChange }) {
  const [focusedInput, setFocusedInput] = useState(null);
  const onDatesChange = dates => {
    onChange({ name, ...dates });
  };
  return (
    <DRP
      noBorder
      small
      withPortal
      endDate={moment(endDate)}
      endDateId="end-date"
      focusedInput={focusedInput}
      numberOfMonths={4}
      startDate={moment(startDate)}
      startDateId="start-date"
      onDatesChange={onDatesChange}
      onFocusChange={setFocusedInput}
    />
  );
}

DateRangePicker.propTypes = {
  name: PropTypes.string,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  onChange: PropTypes.func
};

DateRangePicker.defaultProps = {
  startDate: moment(),
  endDate: moment().add(7, "days")
};
export default DateRangePicker;
